import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X } from "lucide-react";
import { api } from "@/lib/api";

export function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/announcements").then(({ data }) => setItems(data.announcements)).catch(() => {}); }, []);

  const dismiss = (id) => {
    setItems((s) => s.filter((a) => a.id !== id));
    api.post(`/announcements/${id}/dismiss`).catch(() => {});
  };

  if (!items.length) return null;
  return (
    <div className="space-y-2.5 px-5 pt-4" data-testid="announcements">
      {items.map((a) => (
        <div key={a.id} className="relative rounded-2xl border border-[#D4AF37]/40 bg-[#D4AF37]/8 p-4 pr-10" data-testid={`announcement-${a.id}`}>
          <button onClick={() => dismiss(a.id)} aria-label="Chiudi" data-testid={`announcement-close-${a.id}`} className="absolute right-2.5 top-2.5 rounded-full p-1.5 text-[#A1A1AA] hover:text-[#FAF9F6]"><X size={16} /></button>
          <p className="flex items-center gap-2 font-semibold text-[#E5C158]"><Megaphone size={16} /> {a.title}</p>
          <p className="mt-1.5 whitespace-pre-line text-[15px] leading-relaxed text-[#D4D4D8]">{a.message}</p>
          {a.link && (
            <Link to={a.link} onClick={() => dismiss(a.id)} data-testid={`announcement-link-${a.id}`} className="mt-2.5 inline-block text-sm font-semibold text-[#E5C158] underline underline-offset-4">Vai</Link>
          )}
        </div>
      ))}
    </div>
  );
}
